module.exports = __webpack_public_path__ + "media/customizations/austinpoint/logo-b94704d211791e27e0d547de91148b3b.png";